module.exports = __webpack_public_path__ + "static/media/hourglass-half.a2d4de21.svg";